export default __webpack_public_path__ + "images/070fbbcd4236308dd9f79a98df16ca9b.png";